import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageHeaderComponent } from '@app/modules/page/components/page-header/page-header.component';
import { PageSubtitleComponent } from '@app/modules/page/components/page-subtitle/page-subtitle.component';
import { PageTitleComponent } from '@app/modules/page/components/page-title/page-title.component';

@NgModule({
    declarations: [
        PageHeaderComponent,
        PageSubtitleComponent,
        PageTitleComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        PageHeaderComponent,
        PageSubtitleComponent,
        PageTitleComponent
    ]
})
export class PageModule { }
